<template>
  <div class="password-reset-confirm container">
    <div class="my-5">
      <b-row align-h="center" align-v="center">
        <b-col cols="8" md="6" lg="6">
          <b-card no-body class="v2_box_teal">
            <b-card-header class="p-3 v2_box_teal_header">
              <div class="v2_font_size_20">
                Reset Password
              </div>
            </b-card-header>
            <b-card-body class="p-3">
              <b-form>
                <b-form-group
                  label="Enter new password:"
                  label-class="v2_color_primary_teal v2_font_size_18 v2_font_weight_semibold font-weight-bold"
                  class="password-group"
                >
                  <b-row class="password-row">
                    <b-col cols="11">
                      <b-form-input
                        class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black form-control"
                        :type="passwordType"
                        v-model="$v.password.$model"
                        :state="validateState('password')"
                      >
                      </b-form-input>
                    </b-col>
                    <b-col cols="1">
                      <i
                        aria-hidden="true"
                        :class="[
                          'mdi',
                          {
                            'mdi-eye-off': isPasswordVisible,
                            'mdi-eye': !isPasswordVisible,
                          },
                          'clickable',
                          'icon-input__icon-right',
                        ]"
                        @click="isPasswordVisible = !isPasswordVisible"
                      />
                    </b-col>
                  </b-row>
                  <div
                    v-show="$v.password.$anyError"
                    tabindex="-1"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback selector-invalid-feedback"
                  >
                    {{ passwordInvalidFeedback }}
                  </div>
                </b-form-group>
              </b-form>
            </b-card-body>
            <b-card-footer class="v2_bg_transparent">
              <p class="text-right mb-0">
                <b-btn variant="v2_white" class="width_140" @click="onCancel">
                  Cancel
                </b-btn>
                <b-btn
                  variant="v2_primary"
                  class="ml-1 width_140"
                  @click="onSubmit"
                >
                  <template v-if="!saveLoading">Save</template>
                  <template v-else>
                    <b-spinner small />
                    <span>Saving...</span>
                  </template>
                </b-btn>
              </p>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import Api from '@/providers/Api';

export default {
  name: 'PasswordResetConfirm',
  mixins: [validationMixin],
  props: {
    token: String,
  },
  data: function () {
    return {
      password: '',
      passwordRepeat: '',
      isPasswordVisible: false,
      saveLoading: false,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8), // TODO: update after adding global settings
    },
  },
  computed: {
    passwordInvalidFeedback: function () {
      if (!this.$v.password.minLength) {
        return "Password can't be less than 8 characters."; // TODO: update after adding global settings
      }
      return 'This field is required';
    },
    passwordType: function () {
      return this.isPasswordVisible ? 'text' : 'password';
    },
  },
  methods: {
    validateState: function (name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSubmit: async function () {
      this.$v.$touch();

      if (this.$v.$anyError) {
        return;
      }

      try {
        this.saveLoading = true;
        await Api.saveNewPassword(this.token, this.password);
        this.$emit('form-submit', {
          success: 1,
          message: 'Password reset successful.',
        });
      } catch (error) {
        this.$emit('form-submit', {
          success: 0,
          message:
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            'Password reset failed, please contact the system administrator if the problem persists.',
        });
      } finally {
        this.saveLoading = false;
      }
    },
    onCancel: function () {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss">
.password-reset-confirm {
  .password-group {
    div {
      outline: none !important;
    }
    .password-row {
      .icon-input:focus {
        outline: rgb(77, 144, 254) auto 1px !important;
      }
    }
  }
  .invalid-feedback {
    display: block;
  }
}
</style>
